// extracted by mini-css-extract-plugin
export default {"tile":"SupportDirectoryTile_tile__eUX9V"};